const rgb = hex => {
  const value = (hex || "#64748B").replace("#", "")
  const full  = value.length === 3 ? value.split("").map(c => c + c).join("") : value
  return [0, 2, 4].map(start => parseInt(full.slice(start, start + 2), 16))
}

export const tint = (hex, alpha) => {
  const [r, g, b] = rgb(hex)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const readableOn = hex => {
  const [r, g, b] = rgb(hex).map(channel => {
    const value = channel / 255
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return luminance > 0.4 ? "#0F172A" : "#FFFFFF"
}
